export default {"src":"/_next/static/media/family_friendly.1690b834.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};